import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {LocalStorage, LocalStorageUtil} from '../utils/local-storage-util';

export const AuthGuard: CanActivateFn = (next, state) => {
  const router = inject(Router);

  if (LocalStorageUtil.getStorage()?.at) {
    return true;
  } else {
    LocalStorageUtil.setStorage(new LocalStorage());
    return router.createUrlTree(['/auth/login'], {
      queryParams: {redirectUrl: state.url},
    });
  }
};
